import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import "./RFQs.css";

export default function RFQs() {
  const [rfqs, setRfqs] = useState([]);
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");

  /* ================= FETCH RFQS ================= */
  const fetchRFQs = async () => {
    const res = await fetch("http://localhost:5000/api/rfqs");
    const data = await res.json();
    setRfqs(data.rfqs || []);
  };

  useEffect(() => {
    fetchRFQs();
  }, []);

  /* ================= UPDATE RFQ ================= */
  const updateRFQ = async () => {
    await fetch(`http://localhost:5000/api/rfqs/${selected._id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status, notes }),
    });

    setSelected(null);
    fetchRFQs();
  };

  /* ================= DELETE RFQ ================= */
  const deleteRFQ = async (id) => {
    if (!window.confirm("Delete this RFQ?")) return;

    await fetch(`http://localhost:5000/api/rfqs/${id}`, {
      method: "DELETE",
    });

    fetchRFQs();
  };

  return (
    <div className="admin-body">
      <Topbar />
      <Sidebar />

      <main className="admin-main">
        <h1 style={{ color: "#374151" }}>RFQ Management</h1>

        {/* ================= DESKTOP TABLE ================= */}
        <section className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Company</th>
                <th>Email</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {rfqs.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No RFQs found
                  </td>
                </tr>
              ) : (
                rfqs.map((r, i) => (
                  <tr key={r._id}>
                    <td>RFQ-{i + 1}</td>
                    <td>{r.company}</td>
                    <td>{r.email}</td>
                    <td>
                      <span className={`status ${r.status}`}>
                        {r.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="edit"
                        onClick={() => {
                          setSelected(r);
                          setStatus(r.status);
                          setNotes(r.notes || "");
                        }}
                      >
                        ✏️
                      </button>

                      <button
                        className="danger"
                        onClick={() => deleteRFQ(r._id)}
                      >
                        🗑
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </section>

        {/* ================= MOBILE CARDS (ORDER STYLE) ================= */}
        <div className="mobile-rfqs">
          {rfqs.map((r, i) => (
            <div className="rfq-card" key={r._id}>
              <div className="row">
                <span>RFQ ID</span>
                <strong>RFQ-{i + 1}</strong>
              </div>

              <div className="row">
                <span>Company</span>
                <strong>{r.company}</strong>
              </div>

              <div className="row">
                <span>Email</span>
                <strong>{r.email}</strong>
              </div>

              <div className="row">
                <span>Status</span>
                <span className={`status ${r.status}`}>{r.status}</span>
              </div>

              <div className="actions">
                <button
                  onClick={() => {
                    setSelected(r);
                    setStatus(r.status);
                    setNotes(r.notes || "");
                  }}
                >
                  ✏️
                </button>

                <button onClick={() => deleteRFQ(r._id)}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ================= DRAWER ================= */}
      <div className={`drawer ${selected ? "open" : ""}`}>
        {selected && (
          <div className="drawer-content">
            <h2>Update RFQ</h2>

            <label>Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="new">New</option>
              <option value="in-review">In Review</option>
              <option value="quoted">Quoted</option>
              <option value="closed">Closed</option>
            </select>

            <label>Notes</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Internal notes..."
            />

            <div className="drawer-actions">
              <button className="primary" onClick={updateRFQ}>
                Update
              </button>
              <button className="danger" onClick={() => setSelected(null)}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
